import { DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsWrapper = styled.section`
  margin-top: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
`
